import { createContext } from "react";
import { requestsInitialState } from "./requestsInitialState";


const RequestsContext = createContext(requestsInitialState)

export default RequestsContext